import luminousLightbox from '../library/library-luminousLightbox';
import slick from '../library/library-slick.js';
import { acfmap } from '../components/maps.js';
import propertysearch from '../routes/templatePropertysearch.js';

export default {
  init() {
    // JavaScript to be fired on the home page

    // luminous lightbox
    luminousLightbox.init();

    // slick
    slick.init();

    propertysearch.init();

    // google map
    acfmap();

    $( '#hide-btn' ).on( "click", function() {
      $( '.lum-gallery-button' ).addClass('d-none') ;
    });

    $( '#img-wrapper-gallery' ).on( "click", function() {
      $( '.lum-gallery-button' ).removeClass('d-none') ;
    });  

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templatePropertysingle.js